export function encodeString(str: string): string {
    return encodeURIComponent(str);
}

export function decodeUri(uri: string): string {
    return decodeURIComponent(uri);
}
